import Header from "./components/Header";
import Hero from "./components/Hero";
import TickerTrack from "./components/TickerTrack";
import TopicWall from "./components/TopicWall";
import ExposeGrid from "./components/ExposeGrid";
import VerifySection from "./components/VerifySection";
import Collections from "./components/Collections";
import CTABand from "./components/CTABand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-paper font-sans text-ink">
      <Header />
      <main>
        <Hero />
        <TickerTrack />
        <TopicWall />
        <ExposeGrid />
        <VerifySection />
        <Collections />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}